export default __webpack_public_path__ + "fee06aff72c25be4bafb451223442c20.png";